module.exports = __webpack_public_path__ + "static/801377bb62331c275a8dce30876de671a9bcbb1ac021b946ed397abe092013e4-d8df7284ffba10b922b83a18b3e6e279.jpeg";